import BaseAPI from "../api";

const logoPath: string = "app-logo";
const backgroundPath: string = "login-background";

export class CmsApi extends BaseAPI {
  static getAppLogo(): Promise<any> {
    return this.api.get(`${logoPath}`,{ responseType:"arraybuffer" }).then((res) => res);
  }
  static getBackground(): Promise<any> {
    return this.api.get(`${backgroundPath}`,{ responseType:"arraybuffer" }).then((res) => res);
  }
  static updateAppLogo(file: FormData): Promise<any> {
    return this.api.patch(`${logoPath}`, file, { headers:{'Content-Type': 'multipart/form-data'} }).then(res => res);
  }
  static updateBackground(file:FormData):Promise<any>{
    return this.api.patch(`${backgroundPath}`,file,{headers:{'Content-Type': 'multipart/form-data'}}).then(res => res);
  }
}
